export const AddEmptyIcon = () => (
  <svg
    width={357}
    height={136}
    viewBox="0 0 357 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-[136px] w-[300px] sm:w-[356px]"
  >
    <path
      d="M132.859 16.9058L125.586 18.8641C107.338 23.7839 102.025 33.0591 106.944 51.2629L111.862 69.4666C116.082 85.189 123.584 91.3529 137.235 89.5757C139.424 89.3264 141.781 88.8517 144.306 88.1516L151.622 86.1479C169.78 81.1871 175.139 71.9543 170.22 53.7505L165.3 35.5029C164.297 31.8013 163.134 28.5884 161.728 25.955C156.235 15.5049 147.404 12.9453 132.859 16.9058Z"
      fill="url(#paint0_linear_629_2111)"
    />
    <path
      d="M132.859 16.9058L125.586 18.8641C107.338 23.7839 102.025 33.0591 106.944 51.2629L111.862 69.4666C116.082 85.189 123.584 91.3529 137.235 89.5757C139.424 89.3264 141.781 88.8517 144.306 88.1516L151.622 86.1479C169.78 81.1871 175.139 71.9543 170.22 53.7505L165.3 35.5029C164.297 31.8013 163.134 28.5884 161.728 25.955C156.235 15.5049 147.404 12.9453 132.859 16.9058Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M233.013 16.9058L240.286 18.8641C258.533 23.7839 263.846 33.0591 258.928 51.2629L254.01 69.4666C249.79 85.189 242.288 91.3529 228.637 89.5757C226.448 89.3264 224.091 88.8517 221.565 88.1516L214.25 86.1479C196.092 81.1871 190.733 71.9543 195.651 53.7505L200.571 35.5029C201.575 31.8013 202.737 28.5884 204.144 25.955C209.637 15.5049 218.468 12.9453 233.013 16.9058Z"
      fill="url(#paint1_linear_629_2111)"
    />
    <path
      d="M233.013 16.9058L240.286 18.8641C258.533 23.7839 263.846 33.0591 258.928 51.2629L254.01 69.4666C249.79 85.189 242.288 91.3529 228.637 89.5757C226.448 89.3264 224.091 88.8517 221.565 88.1516L214.25 86.1479C196.092 81.1871 190.733 71.9543 195.651 53.7505L200.571 35.5029C201.575 31.8013 202.737 28.5884 204.144 25.955C209.637 15.5049 218.468 12.9453 233.013 16.9058Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M310.64 47.9565L317.913 49.9148C336.161 54.8347 341.474 64.1099 336.555 82.3137L331.637 100.517C327.417 116.24 319.915 122.404 306.264 120.627C304.075 120.377 301.718 119.902 299.193 119.202L291.877 117.199C273.719 112.238 268.36 103.005 273.279 84.8013L278.199 66.5537C279.202 62.8521 280.365 59.6392 281.771 57.0058C287.264 46.5557 296.095 43.9961 310.64 47.9565Z"
      fill="url(#paint2_linear_629_2111)"
    />
    <path
      d="M310.64 47.9565L317.913 49.9148C336.161 54.8347 341.474 64.1099 336.555 82.3137L331.637 100.517C327.417 116.24 319.915 122.404 306.264 120.627C304.075 120.377 301.718 119.902 299.193 119.202L291.877 117.199C273.719 112.238 268.36 103.005 273.279 84.8013L278.199 66.5537C279.202 62.8521 280.365 59.6392 281.771 57.0058C287.264 46.5557 296.095 43.9961 310.64 47.9565Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M46.3601 32.4312L39.087 34.3894C20.8394 39.3093 15.5261 48.5845 20.4446 66.7883L25.363 84.992C29.5827 100.714 37.0848 106.878 50.7359 105.101C52.9248 104.852 55.2819 104.377 57.8072 103.677L65.1226 101.673C83.281 96.7125 88.6396 87.4797 83.7212 69.2759L78.8013 51.0283C77.798 47.3267 76.6354 44.1138 75.2285 41.4804C69.7357 31.0303 60.9046 28.4707 46.3601 32.4312Z"
      fill="url(#paint3_linear_629_2111)"
    />
    <path
      d="M46.3601 32.4312L39.087 34.3894C20.8394 39.3093 15.5261 48.5845 20.4446 66.7883L25.363 84.992C29.5827 100.714 37.0848 106.878 50.7359 105.101C52.9248 104.852 55.2819 104.377 57.8072 103.677L65.1226 101.673C83.281 96.7125 88.6396 87.4797 83.7212 69.2759L78.8013 51.0283C77.798 47.3267 76.6354 44.1138 75.2285 41.4804C69.7357 31.0303 60.9046 28.4707 46.3601 32.4312Z"
      fill="black"
      fillOpacity={0.1}
    />
    <defs>
      <linearGradient
        id="paint0_linear_629_2111"
        x1={128.887}
        y1={9.96065}
        x2={125.322}
        y2={111.476}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_629_2111"
        x1={236.985}
        y1={9.96065}
        x2={240.55}
        y2={111.476}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_629_2111"
        x1={314.612}
        y1={41.0114}
        x2={318.177}
        y2={142.526}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_629_2111"
        x1={42.3878}
        y1={25.486}
        x2={38.8226}
        y2={127.001}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
    </defs>
  </svg>
);
